export type CoverPreset = 'orange' | 'cyan' | 'pink' | 'green';

export const COVER_PRESETS: Record<CoverPreset, { bg: string; border: string; accent: string }> = {
  orange: { bg: 'linear-gradient(160deg,#3d1d00,#1a0a00)', border: 'rgba(242,116,5,0.2)', accent: '#F29D52' },
  cyan: { bg: 'linear-gradient(160deg,#002a3d,#001a2d)', border: 'rgba(5,242,242,0.2)', accent: '#05F2F2' },
  pink: { bg: 'linear-gradient(160deg,#2d0038,#1a002d)', border: 'rgba(244,114,182,0.2)', accent: '#F472B6' },
  green: { bg: 'linear-gradient(160deg,#003d20,#002d1a)', border: 'rgba(74,222,128,0.2)', accent: '#4ADE80' },
};

export const resolvePreset = (v?: string | null): CoverPreset =>
  v && v in COVER_PRESETS ? (v as CoverPreset) : 'orange';
